export default {"src":"/_next/static/media/hostel1.d3558896.svg","height":24,"width":24};